document.addEventListener('DOMContentLoaded', function() {
  // Initialize the fake scrollbar functionality for each multicolumn section
  const multicolumnSections = document.querySelectorAll('.multicolumn');
  
  multicolumnSections.forEach(section => {
    const multicolumnList = section.querySelector('.multicolumn-list');
    const fakeThumb = section.querySelector('.fake-thumb');
    const fakeScrollbar = section.querySelector('.fake-scrollbar');
    
    if (!multicolumnList || !fakeThumb || !fakeScrollbar) return;
    
    // Initial setup - adjust the fake scrollbar thumb width based on scroll ratio
    const contentWidth = multicolumnList.scrollWidth;
    const viewportWidth = multicolumnList.clientWidth;
    
    if (contentWidth <= viewportWidth) {
      // Hide scrollbar if there's nothing to scroll
      fakeScrollbar.style.display = 'none';
      return;
    }
    
    // Calculate thumb width as a percentage of the visible content
    const thumbWidthPercentage = (viewportWidth / contentWidth) * 100;
    fakeThumb.style.width = `${thumbWidthPercentage}%`;
    
    // Sync the fake scrollbar thumb with the actual scroll position
    multicolumnList.addEventListener('scroll', () => {
      const scrollPercentage = multicolumnList.scrollLeft / (multicolumnList.scrollWidth - multicolumnList.clientWidth);
      const maxThumbOffset = fakeScrollbar.clientWidth - fakeThumb.offsetWidth;
      fakeThumb.style.left = `${scrollPercentage * maxThumbOffset}px`;
    });
    
    // Dragging functionality for the fake scrollbar
    let isDragging = false;
    let startX;
    let startLeft;
    
    fakeThumb.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX;
      startLeft = parseInt(window.getComputedStyle(fakeThumb).left, 10) || 0;
      e.preventDefault();
    });
    
    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const deltaX = e.pageX - startX;
      let newLeft = startLeft + deltaX;
      
      // Boundaries for the fake scrollbar thumb
      const maxLeft = fakeScrollbar.clientWidth - fakeThumb.offsetWidth;
      if (newLeft < 0) newLeft = 0;
      if (newLeft > maxLeft) newLeft = maxLeft;
      
      fakeThumb.style.left = `${newLeft}px`;
      
      // Calculate the corresponding scroll position
      const scrollPercentage = newLeft / maxLeft;
      multicolumnList.scrollLeft = scrollPercentage * (multicolumnList.scrollWidth - multicolumnList.clientWidth);
    });
    
    document.addEventListener('mouseup', () => {
      isDragging = false;
    });
    
    // Also add touch support for mobile devices
    fakeThumb.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].pageX;
      startLeft = parseInt(window.getComputedStyle(fakeThumb).left, 10) || 0;
      e.preventDefault();
    });
    
    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const deltaX = e.touches[0].pageX - startX;
      let newLeft = startLeft + deltaX;
      
      // Boundaries for the fake scrollbar thumb
      const maxLeft = fakeScrollbar.clientWidth - fakeThumb.offsetWidth;
      if (newLeft < 0) newLeft = 0;
      if (newLeft > maxLeft) newLeft = maxLeft;
      
      fakeThumb.style.left = `${newLeft}px`;
      
      // Calculate the corresponding scroll position
      const scrollPercentage = newLeft / maxLeft;
      multicolumnList.scrollLeft = scrollPercentage * (multicolumnList.scrollWidth - multicolumnList.clientWidth);
    }, { passive: false });
    
    document.addEventListener('touchend', () => {
      isDragging = false;
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.alt-header')) {
    document.querySelector('.header').classList.add('header--alt');
  }
});


document.querySelectorAll('.image-with-text__content').forEach(section => {
  const firstAccordion = section.querySelector('.accordion');

  if (firstAccordion) {
    firstAccordion.classList.add('accordion--first');
  }
});